<template>
  <v-navigation-drawer app permanent class="sidebar">
    <!-- Logo 區域 -->
    <v-list-item class="logo-container">
      <img src="/logo.png" alt="Logo" style="max-height: 35px; object-fit: contain;" />
    </v-list-item>
    <v-divider></v-divider>

    <!-- 功能選單 -->
    <v-list>
      <v-list-item-group v-model="selected" active-class="active-menu">
        <v-list-item v-for="(menu, index) in menus" :key="index"
          @click="menu.route ? navigate(index) : toggleSubMenu(index)" class="menu-item">
          <div class="menu-content">
            <v-list-item-title>{{ menu.title }}</v-list-item-title>
            <v-icon v-if="menu.icon" class="menu-icon">{{ menu.icon }}</v-icon>
          </div>

        </v-list-item>


      </v-list-item-group>
    </v-list>

    <!-- 底部區域 -->
    <div class="sidebar-bottom">
      <!-- 使用者資訊 -->
      <div class="user-info">
        <div class="user-details">
          <p class="user-name">{{ user.name }}</p>
          <p class="user-role">{{ user.role }}</p>
        </div>
        <v-btn outlined small color="primary" class="change-password-btn" @click="openChangePasswordDialog">
          變更密碼
        </v-btn>
      </div>

      <!-- 登出按鈕 -->
      <v-btn block outlined class="logout-btn" @click="logout">登出</v-btn>
    </div>
  </v-navigation-drawer>
  <v-dialog :key="changePasswordDialogKey" v-model="changePasswordDialogVisible" max-width="400px">

    <v-card>
      <v-card-title class="text-h6">變更密碼</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-text-field v-model="oldPassword" :id="`old-password-${changePasswordDialogKey}`" label="舊密碼" type="password"
          outlined dense autocomplete="off" name="old-password" />
        <v-text-field v-model="newPassword" :id="`new-password-${changePasswordDialogKey}`" label="新密碼" type="password"
          outlined dense autocomplete="new-password" name="new-password" />
        <v-text-field v-model="confirmPassword" :id="`confirm-password-${changePasswordDialogKey}`" label="確認新密碼"
          type="password" outlined dense autocomplete="new-password" name="confirm-password" />
        <form style="display: none; position: absolute; top: -9999px;">
          <input type="text" name="username" autocomplete="username" />
          <input type="password" name="password" autocomplete="new-password" />
        </form>



      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="primary" text @click="changePassword">確認</v-btn>
        <v-btn color="secondary" text @click="closeChangePasswordDialog">取消</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>


</template>

<script>
import axios from "axios";

export default {
  name: "AppSidebar",
  data() {
    return {
      selected: 0,
      changePasswordDialogVisible: false,
      changePasswordDialogKey: Date.now(),
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      menus: [
        { title: "AI工具管理", route: "/tools", icon: "mdi-tools" },
        { title: "標籤管理", route: "/applications", icon: "mdi-tag-multiple" },
        { title: "後台帳號列表", route: "/users/accounts", icon: "mdi-account-group" },
      ],



    };
  },
  computed: {
    user() {
      return {
        name: localStorage.getItem("backendUserAccount") || "未知使用者",
        role: localStorage.getItem("accountStatus") === "-1" ? "系統管理員" : "一般使用者",
        email: localStorage.getItem("email") || "未提供",
        lastLogin: localStorage.getItem("lastTimeLogin") || "未記錄",
      };
    }
  },

  created() {
    this.updateUserInfo();
  },
  mounted() {
    window.addEventListener("storage", this.updateUserInfo);
  },
  beforeUnmount() {
    window.removeEventListener("storage", this.updateUserInfo);
  },
  methods: {
    updateUserInfo() {
      this.user.name = localStorage.getItem("backendUserAccount") || "未知使用者";
      this.user.role = localStorage.getItem("accountStatus") === "-1" ? "系統管理員" : "一般使用者";
      this.user.email = localStorage.getItem("email") || "未提供";
      this.user.lastLogin = localStorage.getItem("lastTimeLogin") || "未記錄";
    },
    openChangePasswordDialog() {
      this.changePasswordDialogKey = Date.now(); // 生成唯一 key
      this.oldPassword = "";
      this.newPassword = "";
      this.confirmPassword = "";
      this.changePasswordDialogVisible = true;
    },
    closeChangePasswordDialog() {
      this.changePasswordDialogVisible = false;
      this.oldPassword = "";
      this.newPassword = "";
      this.confirmPassword = "";
    },
    async changePassword() {
      if (!this.oldPassword || !this.newPassword || !this.confirmPassword) {
        alert("請填寫所有欄位！");
        return;
      }

      if (this.newPassword !== this.confirmPassword) {
        alert("新密碼與確認密碼不一致！");
        return;
      }

      const baseUrl = process.env.VUE_APP_BASE_URL; // API base URL
      try {
        const response = await axios.post(`${baseUrl}/api/v1/users/change-password`, {
          oldPassword: this.oldPassword,
          newPassword: this.newPassword,
        }, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        });

        if (response.data.rtnCode === "0000") {
          alert("密碼變更成功！");
          this.closeChangePasswordDialog();
        } else {
          alert(`密碼變更失敗: ${response.data.rtnMsg}`);
        }
      } catch (error) {
        console.error("API Error:", error.response || error.message);
        alert("密碼變更失敗，請稍後再試！");
      }
    },
    navigate(index) {
      if (this.menus[index].route) {
        this.$router.push(this.menus[index].route);
      }
      this.selected = index; // 設定目前選中的主選單
    },

    navigateSubMenu(subIndex) {
      this.$router.push(this.subMenus[subIndex].route);
    },
    async logout() {
      const baseUrl = process.env.VUE_APP_BASE_URL || `${process.env.VUE_APP_SERVICE_URL}/api/v1`;
      const authToken = localStorage.getItem("authToken");

      if (!authToken) {
        console.warn("未找到 token，直接清除 localStorage 並跳轉到登入頁");
        this.clearSessionAndRedirect();
        return;
      }

      try {
        const headers = {
          Authorization: `Bearer ${authToken}`,
        };

        const response = await axios.post(`${baseUrl}/backend-users/logout`, {}, { headers });

        if (response.data.rtnCode === "0000") {
          console.log("登出成功");
          this.clearSessionAndRedirect();
        } else {
          console.error("登出失敗:", response.data.rtnMsg);
          alert(`登出失敗: ${response.data.rtnMsg}`);
        }
      } catch (error) {
        console.error("API Error:", error.response || error.message);
        alert("登出失敗，請稍後再試！");
        this.clearSessionAndRedirect(); // 即使失敗，也清除 session
      }
    },
    clearSessionAndRedirect() {
      // 清除 localStorage
      localStorage.removeItem("authToken");
      localStorage.removeItem("backendUserAccount");
      localStorage.removeItem("accountStatus");
      localStorage.removeItem("email");
      localStorage.removeItem("lastTimeLogin");
      localStorage.removeItem("permissions");

      // 跳轉到登入頁面
      this.$router.push("/login").then(() => {
        // window.location.reload();
      });
    }


  },
};
</script>

<style scoped>
/* 使用者資訊區域樣式 */
.user-info {
  display: flex;
  /* 水平排列 */
  align-items: center;
  /* 垂直方向置中 */
  justify-content: center;
  /* 水平方向置中 */
  gap: 16px;
  /* 圖像與文字的間距 */
  margin-bottom: 16px;
  /* 與登出按鈕的間距 */
}

.user-avatar {
  flex-shrink: 0;
  /* 確保頭像不會縮小 */
}

.user-details {
  display: flex;
  flex-direction: column;
  /* 垂直排列名稱與角色 */
  line-height: 1.4;
  /* 行高 */
}

.user-name {
  font-size: 16px;
  font-weight: bold;
  margin: 0;
  color: #333333;
}

.user-role {
  font-size: 14px;
  margin: 0;
  color: #666666;
}

/* 側邊欄底部區域 */
.sidebar-bottom {
  position: absolute;
  bottom: 16px;
  /* 距離底部的間距 */
  width: 100%;
  /* 填滿寬度 */
  text-align: center;
  /* 內容置中 */
}

/* 側邊欄樣式 */
.sidebar {
  background-color: #f5f5f5;
  border-right: 1px solid #dcdcdc;
  color: #333333;
}

/* Logo 區域 */
.logo-container {
  justify-content: center;
  display: flex;
  padding: 16px;
  border-bottom: 1px solid #dcdcdc;
}

.logo-img {
  max-height: 60px;
  object-fit: contain;
}

/* 功能選單 */
.menu-item {
  padding: 12px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  /* 讓選單內容置中 */
  align-items: center;
  text-align: center;
}

.menu-item:hover {
  background-color: #eaeaea;
}

.active-menu {
  background-color: #dcdcdc;
}

/* 子選單樣式 */
.submenu-item {
  padding: 10px 30px;
  /* 子選單向右縮排 */
  cursor: pointer;
  display: flex;
  justify-content: center;
  /* 子選單也置中 */
}

.submenu-item:hover {
  background-color: #f0f0f0;
}

/* 功能選單內容 */
.menu-content {
  display: flex;
  align-items: center;
  gap: 8px;
  /* 文字和圖示間距 */
}

/* 箭頭圖示樣式 */
.arrow-icon {
  font-size: 18px;
  color: #666;
  cursor: pointer;
}

.arrow-icon:hover {
  color: #333;
}

/* 底部登出按鈕 */
.sidebar-footer {
  position: absolute;
  bottom: 16px;
  width: 100%;
  padding: 8px;
}

/* 登出按鈕樣式 */
.logout-btn {
  color: #333333;
  border-color: #333333;
}

.logout-btn:hover {
  background-color: #dcdcdc;
}

.user-info {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 16px;
}

.change-password-btn {
  font-size: 12px;
  height: 28px;
  line-height: 28px;
  padding: 0 12px;
}
.menu-icon {
  margin-left: 8px; /* 控制圖示與文字的間距 */
  color: #666;
}

</style>
